import { render, staticRenderFns } from "./imagepicker-item.vue?vue&type=template&id=64b00179&"
import script from "./imagepicker-item.vue?vue&type=script&lang=ts&"
export * from "./imagepicker-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b00179')) {
      api.createRecord('64b00179', component.options)
    } else {
      api.reload('64b00179', component.options)
    }
    module.hot.accept("./imagepicker-item.vue?vue&type=template&id=64b00179&", function () {
      api.rerender('64b00179', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/imagepicker-item.vue"
export default component.exports